module.exports = __webpack_public_path__ + "static/img/antonoil.37d7d886.png";